import React from 'react';
import { Route } from 'react-router-dom';
// Old role pages (SetRoll, SetRollReport) have been replaced by new Role Management pages
// New role routes are in adminRoutes.js: /roles/assign, /roles/staff-by-role, /roles/permissions

export const roleRoutes = (
  <React.Fragment>
    {/* Routes moved to adminRoutes.js */}
  </React.Fragment>
);
